import SEO from '../components/SEO';
import './SimplePage.css';
import ParticleCanvas from '../components/ui/ParticleCanvas';

const FACTS = [
  { num: '2023', label: 'Founded' },
  { num: '5,000+', label: 'Business customers' },
  { num: '40+', label: 'Countries served' },
  { num: '10M+', label: 'Conversations automated' },
];

const DOWNLOADS = [
  { label: 'Zepliq Logo (SVG)', desc: 'Primary logo in light and dark versions', icon: '🎨' },
  { label: 'Brand Colors & Typography', desc: 'Official brand guidelines and color palette', icon: '🖌️' },
  { label: 'Product Screenshots', desc: 'High-resolution dashboard and feature screenshots', icon: '🖼️' },
  { label: 'Founder Bio & Photo', desc: 'Official biography and headshot for press use', icon: '👤' },
];

export default function PressPage() {
  return (
    <div className="simple-page">
      <SEO
        title="Press & Media — Zepliq News, Press Kit & Media Resources"
        description="Download the Zepliq press kit: logos, brand assets, founder bio, product screenshots, and company facts. For media inquiries, contact our PR team directly."
        keywords="Zepliq press kit, Zepliq media resources, WhatsApp automation news, Zepliq press release, Zepliq brand assets, AI chatbot company press"
        canonical="/press"
      />

      <section className="simple-hero">
        <ParticleCanvas className="simple-hero__canvas" />
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">Press Kit</span>
          <h1 className="display-xl simple-hero__title">
            Zepliq in the press.<br />
            <span className="gradient-text">All resources in one place.</span>
          </h1>
          <p className="text-lg simple-hero__sub">
            Everything journalists, bloggers, and content creators need to cover Zepliq.
            For press inquiries, email <strong>support@zepliq.com</strong>
          </p>
        </div>
      </section>

      <section className="simple-section section">
        <div className="container">

          <div className="simple-header">
            <span className="badge badge-accent">Company Facts</span>
            <h2 className="display-lg">Zepliq at a glance</h2>
          </div>
          <div className="simple-stats-row">
            {FACTS.map(f => (
              <div key={f.label} className="simple-stat-card">
                <span className="simple-stat-card__num gradient-text">{f.num}</span>
                <span className="simple-stat-card__label">{f.label}</span>
              </div>
            ))}
          </div>

          <div className="simple-divider" />

          <div className="simple-header">
            <span className="badge badge-brand">About Zepliq</span>
            <h2 className="display-lg">Company overview</h2>
          </div>
          <div className="press-bio">
            <p className="text-lg">
              Zepliq is an AI-powered messaging automation platform that helps businesses automate customer
              conversations across WhatsApp and email. Founded in 2023, Zepliq enables
              businesses to deploy AI chatbots without technical knowledge, through a simple QR code scan.
            </p>
            <p className="text-lg" style={{ marginTop: '1rem' }}>
              The platform includes AI auto-reply, lead capture pipelines, Shopify and WooCommerce order
              confirmation automation, broadcast campaigns, and a full sales CRM — all in one dashboard.
              Zepliq is used by over 5,000 businesses across 40+ countries, automating more than 10 million
              customer conversations to date.
            </p>
          </div>

          <div className="simple-divider" />

          <div className="simple-header">
            <span className="badge badge-accent">Brand Assets</span>
            <h2 className="display-lg">Download resources</h2>
          </div>
          <div className="simple-grid-2">
            {DOWNLOADS.map(d => (
              <div key={d.label} className="simple-card simple-card--row">
                <span className="simple-card__emoji">{d.icon}</span>
                <div>
                  <h3 className="simple-card__title">{d.label}</h3>
                  <p className="simple-card__desc">{d.desc}</p>
                </div>
                <button className="btn btn-secondary" style={{ marginLeft: 'auto', flexShrink: 0 }}>
                  Download
                </button>
              </div>
            ))}
          </div>

          <div className="simple-divider" />

          <div className="simple-cta-box">
            <h2 className="display-md">Press inquiries</h2>
            <p className="text-lg">For interviews, quotes, or media partnerships, reach out directly.</p>
            <div className="simple-cta-actions">
              <a href="mailto:support@zepliq.com" className="btn btn-primary btn-lg">support@zepliq.com</a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
